import { Email } from '@/components/common/text_input/Email';
import { PartnerExportEmailRequestDto } from '@/models/Admin/Emails/EmailRequestDtos';
import { programIdToProgramName, ProgramNames } from '@/models/Program';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React from 'react';

type Props = {
  form: PartnerExportEmailRequestDto;
  setForm: React.Dispatch<React.SetStateAction<PartnerExportEmailRequestDto>>;
  programOptions: ProgramNames[];
};

const PartnerExportForm: React.FC<Props> = ({ form, setForm, programOptions }) => {
  return (
    <Stack spacing={2}>
      <Email
        fullWidth
        label='Email'
        required
        value={form.Email ?? ''}
        onChange={(e) => setForm((prev) => ({ ...prev, Email: e.target.value }))}
      />
      <FormControl fullWidth required>
        <InputLabel id='partner-export-program-label'>Program</InputLabel>
        <Select
          labelId='partner-export-program-label'
          value={String(form.Program)}
          label='Program'
          onChange={(e) =>
            setForm((prev) => ({
              ...prev,
              Program: Number(e.target.value),
            }))
          }
        >
          {programOptions.map((programId) => (
            <MenuItem key={programId} value={String(programId)}>
              {programIdToProgramName[programId]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default PartnerExportForm;
